/**
 * D&B Poker — Predictive search (title + tag, author collections first)
 * Replaces legacy /search?view=json autocomplete.
 */
(function () {
  'use strict';

  var MIN_CHARS = 2;
  var DEBOUNCE_MS = 300;
  var PRODUCT_LIMIT = 6;
  var COLLECTION_LIMIT = 4;
  var SEARCH_FIELDS = 'title,tag';
  var RESOURCE_TYPES = 'collection,product';

  function debounce(fn, wait) {
    var timer;
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function rootPath() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (typeof root !== 'string') root = '/';
    if (!root.length) root = '/';
    if (root.charAt(0) !== '/') root = '/' + root;
    if (root.charAt(root.length - 1) !== '/') root = root + '/';
    return root;
  }

  function storefrontUrl(path) {
    var cleanPath = String(path || '').replace(/^\/+/, '');
    return window.location.origin + rootPath() + cleanPath;
  }

  function getKeywordRules() {
    var el = document.getElementById('search-keyword-rules');
    if (!el) return [];
    try {
      var parsed = JSON.parse(el.textContent || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function normalizeQuery(q) {
    return (q || '').trim().toLowerCase();
  }

  function tokenCount(q) {
    return normalizeQuery(q).split(/\s+/).filter(Boolean).length;
  }

  function matchKeywordRules(query) {
    var q = normalizeQuery(query);
    if (!q) return [];
    var rules = getKeywordRules();
    var matches = [];
    rules.forEach(function (rule) {
      if (!rule || !rule.url) return;
      (rule.keywords || []).forEach(function (keyword) {
        var k = normalizeQuery(keyword);
        if (!k) return;
        if (q === k || q.indexOf(k) === 0) {
          matches.push(rule);
        }
      });
    });
    return matches;
  }

  function buildSuggestUrl(query) {
    var url = new URL(storefrontUrl('search/suggest.json'));
    url.searchParams.set('q', query);
    url.searchParams.set('resources[type]', RESOURCE_TYPES);
    url.searchParams.set('resources[limit_scope]', 'each');
    url.searchParams.set('resources[limit]', String(Math.max(PRODUCT_LIMIT, COLLECTION_LIMIT)));
    url.searchParams.set('resources[options][fields]', SEARCH_FIELDS);
    url.searchParams.set('resources[options][unavailable_products]', 'hide');
    return url.toString();
  }

  function formatMoney(price) {
    var dollars = parseFloat(price);
    if (isNaN(dollars)) return '';
    var cents = Math.round(dollars * 100);
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    return '$' + dollars.toFixed(2);
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function collectionAuthorUrl(handle) {
    return storefrontUrl('collections/' + handle);
  }

  function shouldHideProductsForAmbiguousQuery(query, collections) {
    return tokenCount(query) === 1 && collections.length > 1;
  }

  function renderRuleItem(rule) {
    var label = rule.label || rule.url;
    var subtitle = rule.type === 'author' ? 'All books by this author' : 'Suggested result';
    return (
      '<li class="search-results__item search-results__item--author">' +
      '<a href="' + escapeHtml(rule.url) + '">' +
      '<span class="thumbnail search-results__icon">&#128214;</span>' +
      '<span class="title"><strong>' + escapeHtml(label) + '</strong><br>' +
      '<small class="search-results__subtitle">' + escapeHtml(subtitle) + '</small></span>' +
      '</a></li>'
    );
  }

  function renderCollectionItem(collection) {
    var img = collection.featured_image && collection.featured_image.url
      ? '<img src="' + escapeHtml(collection.featured_image.url) + '" alt="" width="50" height="50">'
      : '<span class="search-results__icon">&#128214;</span>';
    return (
      '<li class="search-results__item search-results__item--author">' +
      '<a href="' + escapeHtml(collection.url) + '">' +
      '<span class="thumbnail">' + img + '</span>' +
      '<span class="title"><strong>' + escapeHtml(collection.title) + '</strong><br>' +
      '<small class="search-results__subtitle">All books by this author</small></span>' +
      '</a></li>'
    );
  }

  function renderProductItem(product) {
    var img = product.featured_image && product.featured_image.url
      ? product.featured_image.url
      : (product.image || '');
    var thumb = img
      ? '<img src="' + escapeHtml(img) + '" alt="">'
      : '';
    return (
      '<li class="search-results__item search-results__item--product">' +
      '<a href="' + escapeHtml(product.url) + '">' +
      '<span class="thumbnail">' + thumb + '</span>' +
      '<span class="title">' + escapeHtml(product.title) + '</span>' +
      '<span class="price title money">' + formatMoney(product.price) + '</span>' +
      '</a></li>'
    );
  }

  function renderResults(query, data, resultsList) {
    var results = (data && data.resources && data.resources.results) || {};
    var collections = results.collections || [];
    var products = results.products || [];
    var ruleMatches = matchKeywordRules(query);
    var html = [];
    var seenUrls = {};

    ruleMatches.forEach(function (rule) {
      if (seenUrls[rule.url]) return;
      seenUrls[rule.url] = true;
      html.push(renderRuleItem(rule));
    });

    collections.forEach(function (collection) {
      if (seenUrls[collection.url]) return;
      seenUrls[collection.url] = true;
      html.push(renderCollectionItem(collection));
    });

    if (!shouldHideProductsForAmbiguousQuery(query, collections)) {
      products.slice(0, PRODUCT_LIMIT).forEach(function (product) {
        if (seenUrls[product.url]) return;
        seenUrls[product.url] = true;
        html.push(renderProductItem(product));
      });
    } else if (collections.length > 1) {
      html.push(
        '<li class="search-results__item search-results__item--hint">' +
        '<span class="title">Several authors match — type a surname or full name</span></li>'
      );
    }

    if (!html.length) {
      resultsList.innerHTML =
        '<li class="search-results__item"><span class="title">No results found</span></li>';
      resultsList.style.display = 'block';
      return;
    }

    var searchPageUrl = storefrontUrl('search') + '?type=product&q=' + encodeURIComponent(query);
    html.push(
      '<li class="search-results__item search-results__item--more">' +
      '<span class="title"><a href="' + escapeHtml(searchPageUrl) + '">See all results</a></span></li>'
    );

    resultsList.innerHTML = html.join('');
    resultsList.style.display = 'block';

    if (typeof Currency !== 'undefined' && Currency.cookie && Currency.cookie.read && Currency.convertAll) {
      try {
        Currency.convertAll(shopCurrency, Currency.cookie.read());
      } catch (e) { /* ignore */ }
    }
  }

  function fetchSuggestions(query, signal) {
    return fetch(buildSuggestUrl(query), {
      method: 'GET',
      credentials: 'same-origin',
      signal: signal
    }).then(function (response) {
      if (!response.ok) throw new Error('Search failed: ' + response.status);
      return response.json();
    });
  }

  function initHeaderSearch() {
    var containers = document.querySelectorAll('#search-by-category .search-container');
    if (!containers.length) {
      containers = document.querySelectorAll('.search-container, form[action*="/search"]');
    }
    if (!containers.length) return;

    containers.forEach(function (container) {
      var input = container.querySelector('input[name="q"]');
      if (!input) return;

      container.style.position = 'relative';
      input.setAttribute('autocomplete', 'off');

      var resultsList = container.querySelector('ul.search-results');
      if (!resultsList) {
        resultsList = document.createElement('ul');
        resultsList.className = 'search-results';
        resultsList.setAttribute('role', 'listbox');
        resultsList.setAttribute('aria-label', 'Search suggestions');
        container.appendChild(resultsList);
      }

      var offSet = input.offsetTop + input.offsetHeight;
      resultsList.style.position = 'absolute';
      resultsList.style.left = '0';
      resultsList.style.top = offSet + 'px';

      var abortController = null;
      var lastTerm = '';

      var onInput = debounce(function () {
        var term = input.value.trim();

        if (term.length < MIN_CHARS) {
          resultsList.innerHTML = '';
          resultsList.style.display = 'none';
          lastTerm = '';
          return;
        }

        if (term === lastTerm) return;
        lastTerm = term;

        if (abortController) abortController.abort();
        abortController = new AbortController();

        fetchSuggestions(term, abortController.signal)
          .then(function (data) {
            renderResults(term, data, resultsList);
          })
          .catch(function (err) {
            if (err.name === 'AbortError') return;
            resultsList.innerHTML =
              '<li class="search-results__item"><span class="title">Search unavailable — try again</span></li>';
            resultsList.style.display = 'block';
          });
      }, DEBOUNCE_MS);

      input.addEventListener('input', onInput);
      input.addEventListener('focus', function () {
        if (resultsList.innerHTML && input.value.trim().length >= MIN_CHARS) {
          resultsList.style.display = 'block';
        }
      });
    });

    document.addEventListener('click', function (event) {
      if (!event.target.closest('#search-by-category .search-container')) {
        document.querySelectorAll('#search-by-category ul.search-results').forEach(function (list) {
          list.style.display = 'none';
        });
      }
    });
  }

  function initSearchPage() {
    var mount = document.getElementById('search-page-authors');
    if (!mount) return;

    var query = mount.getAttribute('data-query') || '';
    if (query.trim().length < MIN_CHARS) return;

    fetchSuggestions(query)
      .then(function (data) {
        var results = (data && data.resources && data.resources.results) || {};
        var collections = results.collections || [];
        var ruleMatches = matchKeywordRules(query);
        if (!collections.length && !ruleMatches.length) return;

        var html = ['<div class="search-author-collections row">'];

        ruleMatches.forEach(function (rule) {
          html.push(
            '<div class="col-sm-6 col-md-4 search-author-collections__card">' +
            '<a href="' + escapeHtml(rule.url) + '" class="search-author-collections__link">' +
            '<strong>' + escapeHtml(rule.label || rule.url) + '</strong>' +
            '<span>View all books</span></a></div>'
          );
        });

        collections.forEach(function (collection) {
          html.push(
            '<div class="col-sm-6 col-md-4 search-author-collections__card">' +
            '<a href="' + escapeHtml(collection.url) + '" class="search-author-collections__link">' +
            (collection.featured_image && collection.featured_image.url
              ? '<img src="' + escapeHtml(collection.featured_image.url) + '" alt="">'
              : '') +
            '<strong>' + escapeHtml(collection.title) + '</strong>' +
            '<span>View all books</span></a></div>'
          );
        });

        html.push('</div>');
        mount.innerHTML = html.join('');
      })
      .catch(function () { /* non-critical */ });
  }

  function init() {
    initHeaderSearch();
    initSearchPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
